import { SurveyQuota } from '../models';

/**
 * A quota has supplier-level edits when at least one supplier's target diverges
 * from the quota goal and that supplier still needs completes. Editing such a
 * quota's current target triggers the pro-rata confirmation. Ported from the
 * legacy `supplierCurrentTargetChanged` check.
 */
export function hasSupplierLevelQuotaEdit(quota: SurveyQuota): boolean {
  return quota.suppliers.some(
    (supplier) =>
      supplier.currentTarget !== quota.goal && !!supplier.completeNeeded,
  );
}
